<template lang="pug">
  .grey
    .stakeholder-container
      b-container
        b-row(class="justify-content-md-center")
          b-col.text-center(cols="12" lg="7")
            Message(
              :fontSizes="[40, 24]"
              title="A versatile platform with broad applicability"
              subtitle="Our tools help a broad set of decision-makers identify, analyze and visualize data to support their analyses. We seek to bring to a wide range of sectors the data analytics capabilities that have long been restricted to marketing, tech or public markets investing."
            )
          b-col.text-center(cols="12" lg="7")
            .title Our tools can be used by various stakeholders...
          b-col(col lg="12")
            .icon-container
              IconDuo(v-for="(s, i) of stakeholders" :icon="s.image" :title="s.title" :key="i")
        b-row(class="justify-content-md-center")
          b-col.text-center(cols="12" lg="4")
            .title.mb-5 ...for a large spectrum of analyses and tasks
        b-row(class="justify-content-md-center").pb-5
          b-col.text-center(cols="12" lg="4" v-for="(t, i) of tasks" :key="i")
            IconTrio(:icon="t.image" :title="t.title" :text="t.text" :key="i")


</template>
<script type="text/javascript">

import IconDuo from '@/components/Home/IconDuo.vue'
import IconTrio from '@/components/Home/IconTrio.vue'
import Message from '@/components/Shared/Message.vue'

export default {
  name: 'StakeHolderTask',
  components: {
    IconDuo,
    IconTrio,
    Message
  },
  data(){
    return {
      stakeholders: [
        {
          key: 'Investors',
          title: 'Investors',
          image: 'Icon Investors.svg'
        },
        {
          key: 'Board Members',
          title: 'Board Members',
          image: 'Icon Board Members.svg'
        },
        {
          key: 'Corporate Executives',
          title: 'Corporate Executives',
          image: 'Icon Corporate Executives.svg'
        },
        {
          key: 'Advisors',
          title: 'Advisors',
          image: 'Icon Advisors.svg'
        },
        {
          key: 'Analysts',
          title: 'Analysts',
          image: 'Icon Analysts.svg'
        }
      ],
      tasks: [
        {
          key: 'target',
          title: 'Target Identification',
          text: 'Identify comprehensive lists of targets matching detailed criteria. Keep track of the latest news and developments.',
          image: 'Icon Target.svg'
        },
        {
          key: 'opportunity',
          title: 'Opportunity Prioritization',
          text: "Enrich opportunities' descriptions with the relevant data (e.g. macroeco, valuation, competitive facts) to improve the prioritization process.",
          image: 'Icon Opportunity prioritization.svg'
        },
        {
          key: 'benchmarking',
          title: 'Benchmarking',
          text: 'Compare internal KPIs against the wealth of information disclosed by competitors, peers, intermediaries, etc.',
          image: 'Icon Benchmarking.svg'
        },
        {
          key: 'strategic',
          title: 'Strategic Planning',
          text: 'Automate the gathering of sector facts from competitors’ websites, financial and regulatory disclosures, press releases. Devise strategic priorities and execution plans accordingly.',
          image: 'Icon Strategic planning.svg'
        },
        {
          key: 'performance',
          title: 'Performance assessment',
          text: 'Put internal numbers in the context of the long term trends apparent in industry-wide data, peer results, macroeco trends, and other indicators.',
          image: 'Icon Performance Assessment.svg'
        }
      ]
    }
  }
}
</script>


<style scoped lang="scss">
$color-title: #364149;
$color-subtitle: #767F86;

.grey {
  background-color: #F7F8FC;
}

.title {
  color: $color-title;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 40px;
  padding-top: 86px;
}

@media only screen and (min-width: 991px) {
  .icon-container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 50px;
  }

  .stakeholder-container{
    background: url("../../assets/imagesnew/HP-bg-image-min.jpg");
    background-size: 100% 60%;
    background-position: bottom;
    background-repeat: no-repeat;
    overflow: hidden;
  }

}

@media only screen and (max-width: 991px) {
  .icon-container {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 50px;
  }

  .stakeholder-container{
    background: url("../../assets/imagesnew/HP-bg-image-min.jpg");
    background-size: 400% 40%;
    background-position: bottom;
    background-repeat: no-repeat;
    overflow: hidden;
  }
}
</style>